import React from "react";
import AUD from "../../images/AUD.png";
import EntryImage from "../shared/EntryImage";
import { entryVenueCoverage } from "../shared/Helpers";
import { AudioControls } from "../shared/useAudioControls";
import { useNavUtils } from "../shared/useNavUtils";
import MusicController from "./MusicController";
import "./PlayerBar.scss";

export const PlayerBar: React.FC<{
  audioControls: AudioControls;
}> = (props): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const SBD = require(`../../images/${process.env.REACT_APP_SBD_IMAGE}`);

  const navUtils = useNavUtils();

  const entry = props.audioControls.getEntry();
  const track = props.audioControls.getTrack();

  return (
    <div className="ui menu bottom fixed PlayerBar">
      <div className="ui container">
        <div className="item mobile-hidden">
          {entry ? (
            entry.image ? (
              <EntryImage image={entry.image} />
            ) : (
              <div className="ui tiny image">
                <img src={entry.isSoundboard ? SBD : AUD} />
              </div>
            )
          ) : null}
        </div>
        <div className="item track-display-item">
          {entry && track ? (
            <h3 className="ui header">
              {track.title}
              {props.audioControls.isRadio() ? (
                <i className="ui icon small compact disc"></i>
              ) : null}
              <div className="sub header">{entry.date}</div>
              <div className="sub header">{entryVenueCoverage(entry)}</div>
            </h3>
          ) : null}
        </div>
        <div className="item music-controller-item mobile-hidden">
          <MusicController audioControls={props.audioControls} />
        </div>
        <div className="item expand-item">
          <i
            className="ui chevron circle up big link icon"
            onClick={navUtils.mobilePlayer}
          ></i>
        </div>
      </div>
    </div>
  );
};

export default PlayerBar;
